import { useState } from "react";
import { AnimatePresence } from "framer-motion";
import { Bell } from "lucide-react";

import { useNotifications } from "@/components/notifications/useNotifications";
import NotificationsPanel from "@/components/notifications/NotificationsPanel";

/**
 * NotificationsBell — top-bar button that opens a popover with the activity
 * feed. Behaviour split into focused modules under `components/notifications/`:
 *   - useNotifications (hook): polling, milestone toasts, cheer prompts,
 *     mark-read actions.
 *   - NotificationsPanel + NotificationItem (UI parts).
 *
 * This file is the trigger button + open-state wiring only.
 */
export default function NotificationsBell() {
  const { items, unread, markOne, markAll } = useNotifications();
  const [open, setOpen] = useState(false);

  return (
    <div className="relative">
      <button
        data-testid="notifications-bell"
        onClick={() => setOpen((v) => !v)}
        className="w-9 h-9 rounded-full glass flex items-center justify-center hover:text-[#00E5FF] relative"
        title="Notifications"
      >
        <Bell size={16} />
        {unread > 0 && (
          <span
            data-testid="notifications-unread-badge"
            className="absolute -top-1 -right-1 min-w-[18px] h-[18px] px-1 rounded-full bg-[#F5C542] text-white text-[10px] font-bold flex items-center justify-center"
          >
            {unread > 9 ? "9+" : unread}
          </span>
        )}
      </button>

      <AnimatePresence>
        {open && (
          <NotificationsPanel
            items={items}
            unread={unread}
            onMarkRead={markOne}
            onMarkAll={markAll}
            onClose={() => setOpen(false)}
          />
        )}
      </AnimatePresence>
    </div>
  );
}
